import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { CalendarBlank } from '@liveauctioneers/hammer-ui-core/icons';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { Menu } from '@liveauctioneers/hammer-ui-core/menu';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { Event } from '@/types/Event';

import { AddToCalendarLink } from './AddToCalendarLink';

const DEFAULT_LIST_ITEMS = [
    { key: 'apple', label: 'Apple Calendar' },
    { key: 'google', label: 'Google' },
    { key: 'outlook', label: 'Outlook' },
    { key: 'outlookcom', label: 'Outlook.com' },
    { key: 'yahoo', label: 'Yahoo' },
];

type Props = {
    buttonLabel?: string;
    buttonWrapperClass?: string;
    className?: string;
    event: Event;
    onClick?: (calendarTypeId: string, calendarType: string) => void;
    variant?: 'button' | 'inline';
};

export const AddToCalendar = ({
    buttonLabel = 'Add to My Calendar',
    buttonWrapperClass,
    className,
    event,
    onClick,
    variant = 'button',
}: Props) => {
    const trigger =
        variant === 'inline' ? (
            <InlineButton
                aria-label="Add auction to calendar"
                size="sm"
                icon={CalendarBlank}
                iconPlacement="left"
            >
                {buttonLabel}
            </InlineButton>
        ) : (
            <div className={cn(buttonWrapperClass)}>
                <Button
                    aria-label="Add auction to calendar"
                    variant="outlined"
                >
                    {buttonLabel}
                </Button>
            </div>
        );

    return (
        <Menu
            hasRoundedBorders
            isCustomContent
            menuPlacement="bottom-start"
            menuSize="sm"
            numberOfColumns={1}
            trigger={trigger}
        >
            <div className={cn('flex min-w-[180px] flex-col', className)}>
                {DEFAULT_LIST_ITEMS.map(({ key, label }) => (
                    <AddToCalendarLink
                        className="block px-sm py-xs text-text-primary no-underline hover:bg-background-secondary hover:text-link-hover"
                        event={event}
                        key={key}
                        keyName={key}
                        label={label}
                        onClick={(linkType) => onClick?.(linkType, label)}
                        target="_blank"
                    />
                ))}
            </div>
        </Menu>
    );
};
